import { version } from "../../package.json";

export function logThemeInfo() {
  console.log(`Enseigner l'égalité v${version} (${import.meta.env.MODE})`);
}
